<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><i>CONTENTS</i></p>
<p class="toc"><a href="#/foreword">Foreword, by Susan Braden</a></p>
<p class="toc"><a href="#/acknowledgement">Acknowledgments</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. The Legend of Red Bird</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Lady Fenwick: The Day They Buried the Lady—Again</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Emily Ingham: Pioneer Educator</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Ann Hart: A Journey Together</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Jeannette Hart: Romance as Fiction, by Elizabeth Kenney</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. The Minister’s Marriage: Forgive Us Our Trespasses</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Calista Vinton Luther: A Mission of Service</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Maria Sanford: Saybrook’s Minnesota Connection</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Katharine Houghton Hepburn: Organize, Agitate, Educate</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Anna James: Confidant and Conscience of the Community</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Ann Petry: On the Street Where She Lived</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Katharine Hepburn: At Home in Fenwick</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Kathleen E. Goodwin: Her Community Classroom</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. <i>Saybrook Sez</i>: Once Upon a Time</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. Steffie Walters: Point of Destiny</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">16. Marion Houghton Hepburn Grant: Independent Author</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">17. Barbara J. Maynard: “Town Mother,” by Ann Gamble</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">18. Women’s Club: Done Doing Good</span></p>
<p class="toc"><span href="#/chapter19" title="Link target outside of Sample">19. Looking Forward: Remarkable Women on the Way</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1caeb9c8